<template>
  <router-view></router-view>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
    name: 'app',
    methods:{
      ...mapActions('setting', {
        getSys:'getSysAction',
        getRooms: 'getRoomsAction',
        getPeriodsDefs: 'getPeriodsDefsAction',
      }),
    },
    async created() {
      await this.getSys();
      await this.getRooms();
      await this.getPeriodsDefs();
    }
  }
</script>